import { ICategory, ICategoryResponse, ICategoryFilter } from './../interfaces/ICategory';
import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';
import { CategoryMapper } from '../mappers/category.mapper';

export const categoriesApi = createApi({
  reducerPath: 'categoryApi',
  tagTypes: ['Category'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getCategoriesList: build.query<
      ICategoryResponse,
      ICategoryFilter
    >({
      transformResponse: (response: { data: ICategoryResponse }) =>
        response.data,
      query: ({ page, query }) => ({
        url: '/categories/list',
        method: 'GET',
        params: {
          page,
          search: query,
        },
      }),
      providesTags: () => ['Category'],
    }),
    // getCategoriesShortList: build.query<ICategory[], any>({
    //   transformResponse: (response: { data: ICategory[] }) => 
    //     CategoryMapper.toListUI(response.data),
    //   query: () => ({
    //     url: '/categories/short-list',
    //     method: 'GET',
    //   }),
    //   providesTags: () => ['Category'],
    // }),
    getCategory: build.query<ICategory, number | string>({
      transformResponse: (response: { data: ICategory }) => 
        CategoryMapper.toLocal(response.data),
      query: (id) => ({
        url: `/categories/${id}`,
        method: 'GET',
      }),
      providesTags: () => ['Category'],
    }),
    createCategory: build.mutation<ICategory, any>({
      transformResponse: (response: { data: ICategory }) => 
        CategoryMapper.toLocal(response.data),
      query: (newCategory) => {
        return {
          url: '/categories/create',
          method: 'POST',
          body: CategoryMapper.toCreateRequest(newCategory),
        };
      },
      invalidatesTags: ['Category'],
    }),
    updateCategory: build.mutation<ICategory, { id: number | string; data: any }>({
      transformResponse: (response: { data: ICategory }) => 
        CategoryMapper.toLocal(response.data),
      query: ({ id, data }) => {
        return {
          url: `/categories/${id}`,
          method: 'PATCH',
          body: CategoryMapper.toUpdateRequest(Number(id), data),
        };
      },
      invalidatesTags: ['Category'],
    }),
    deleteCategory: build.mutation<ICategory, number>({
      query: (categoryId) => {
        return {
          url: `/categories/${categoryId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Category'],
    }),
  }),
});


export default categoriesApi;